/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState} from "react";
import FormFilter from "../../shared/forms/FormFilter/FormFilter";
import useApiSolicituVacante from "../../api/administracion/useApiSolicituVacante";
import useForm from "../../shared/forms/useForm";
import Filters from "../../shared/forms/FormFilter/Filters";
import Field from "../../shared/forms/Field";
import Buttons from "../../shared/forms/FormFilter/Buttons";
import ButtonIcon from "../../shared/controls/ButtonIcon";
import {AgGridColumn, AgGridReact} from "ag-grid-react";
import agGridHelper from "../../shared/ag-grid-helper";
import FormCalendarRange from "../../shared/forms/FormFields/FormCalendarRange";
import moment from "moment";
import constantesAdministracion from "../../administracion/constantes";
import {FormattedDate} from "react-intl";
import SolicituVacantesDetalle from "./solicitudVacantesDetalle";
import {getSessionState} from "../../hooks/useSessionState";
import FieldCalendar from "../../shared/controls/fieldCalendar";
import useSessionState from "../../hooks/useSessionState";
import {useAuth} from "../../Seguridad/AuthProvider";
import { Dialog } from "primereact/dialog";
import FieldTextArea from "../../shared/controls/fieldTextArea";
import alerts from "../../shared/alerts";
import { Button } from "primereact/button";
import FieldDropDown from '../../shared/controls/fieldDropDown';
import {serialize} from "object-to-formdata";
import constantes from "../../catalogos/constantes";
const filtroInicial = {
    fecha: [moment().startOf("month")._d, moment().startOf("day")._d],
    EnBaja: false
};

const SolicitudVacantes= ({esSeccionAutorizar, soloLectura}) => {
    const api = useApiSolicituVacante();
    const [datos, setDatos] = useState([]);
    const [solicitudVacanteId, setsolicitudVacanteId] = useState(null);
    const {values: filter, onChange: onFilterChange, onClear} = useForm(filtroInicial);
    const puedeEditar = true;
    const {user: usuario} = useAuth();
    const [,setId] = useState(null);
    const filtroKey = "FiltroSolicitudVacantes";
    const [,setFiltro] = useSessionState(filtroKey, {}, filtroInicial);
    const [verModal, setVerModal] = useState(false);
    const [verModalEntrevista,setVerModalEntrevista]= useState(false);
    const solicitante = {
        id: usuario.empleadoId,
        nombre: usuario.nombre
    };
    
    const filtrar = async (filtro) => {
        const newFiltro = {...filtro,   esSeccionAutorizar: esSeccionAutorizar};
        const datos = await api.filtrar(newFiltro)
        
        setDatos(datos);
        setFiltro(filtro);
    };
    const nuevoCargo = (id) => {
        setId(id);
    };
    const [comentario, setComentario] = useState("");
    const [motivo, setMotivo] = useState("");
    const [motivoCancelacionOperativo, setmotivoCancelacionOperativo] = useState("");
    const [fechaCancelacion,setFechaCancelacion]= useState(moment().startOf("day")._d,);
    const [fechaEntrevista,setFechaEntrevista]= useState(moment().startOf("day")._d,);
    const [solciitudId,setSolicitudId]= useState(0);
    const [EsOperador ,setEsOperador] = useState(0);

const NivelCellRenderer = (value) => {
    const prioridad = value?.data?.prioridad;

    if (prioridad === constantesAdministracion.prioridadIncidencia.Nivel1) {
        return (
            <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <img
                    src="../../../../img/nivel1.png"
                    alt="Nivel 1"
                    width="15px"
                />
                Nivel 1
            </span>
        );
    }

    if (prioridad === constantesAdministracion.prioridadIncidencia.Nivel2) {
        return (
            <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <img
                    src="../../../../img/nivel2.png"
                    alt="Nivel 2"
                    width="15px"
                />
                Nivel 2
            </span>
        );
    }

    if (prioridad === constantesAdministracion.prioridadIncidencia.Nivel3) {
        return (
            <span style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <img
                    src="../../../../img/nivel3.png"
                    alt="Nivel 3"
                    width="15px"
                />
                Nivel 3
            </span>
        );
    }

    return null;
};


    function exportar() {
        var filtro = getSessionState(filtroKey);
        if (filtro !== null) api.excel(filtro);
    }

  const cancelar = async () => {      
        const data = {
            motivoCancelacion: motivo.id,
            comentariosCancelacion: comentario,
            fechaCancelacion: fechaCancelacion,
            motivoCancelacionOperativo: motivoCancelacionOperativo
           
        }        
        console.log(data)
        const formData = serialize(data ?? {}, {indices: true, dotsForObjectNotation: true});
        await api.cancelar(solciitudId,formData);
        setVerModal(false);
    };
      const cancelarEntrevista = async () => {      
        const data = {           
            fechaEntrevista: fechaEntrevista
           
        }        
        const formData = serialize(data ?? {}, {indices: true, dotsForObjectNotation: true});
        await api.entrevista(solciitudId,formData);
        setVerModalEntrevista(false);
    };
    async function aceptar(id) {       
               if (await alerts.preguntarSiNo(`${"Aceptar solicitud"}, ¿deseas continuar?`)) {
                await api.aceptar(id);
            }
    }
    async function cancelarModal(id,operador) {            
        if (await alerts.preguntarSiNo(`${"Cancelar solicitud" }, ¿deseas continuar?`)) {                  
                setComentario("");
                setSolicitudId(id);
                setEsOperador(operador)
                setVerModal(true);  
                       
        }
        
    }
    async function entrevistaModal(id) {            
        if (await alerts.preguntarSiNo(`${"Solicitar entrevista" }, ¿deseas continuar?`)) {        
                
                setSolicitudId(id)
                setVerModalEntrevista(true);  
                       
        }
        
    }

    const ButtonsHeader = () => (
        <div className={"ag-grid header-icons"}>
            <ButtonIcon title={"Descargar"} onClick={exportar} iconName={"BiDownload"}/>

            {puedeEditar && (
                <ButtonIcon
                    title="Agregar"
                    className={"grid-action"}
                    iconName={"MdAddBox"}
                    onClick={() => setsolicitudVacanteId(0)}
                />
            )}
        </div>
    );

    const DateCellRenderer = ({value}) => (
        <div>
            <FormattedDate value={value} weekday="short"/> &nbsp;
            {moment(value).format("DD/MM/YYYY")}
        </div>
    );

    const ButtonsDetail = ({data, context}) => (
        <div className={"ag-grid row-icons"}>
            {data.agregarCargo &&
                <ButtonIcon title={"Agregar Cargo"} iconName={"MdAddBox"} onClick={() => nuevoCargo(data.id)}/>
            }
            <ButtonIcon title={"Editar"} iconName={"FaRegEdit"} onClick={() => context.onEdit(data.id)}/>
        </div>
    );

    const CancelarCellRenderer = ({ data }) => {
    const estatusId = data?.estatusId;
    if (soloLectura || (estatusId === constantes.estatusSolicitudVacantes.Cerrada  ||  estatusId=== constantes.estatusSolicitudVacantes.Cancelada )) {
        return null; 
    }

    return (
        <div className="d-flex align-items-center justify-content-center">
        <button
            title="Cancelar"
            type="button"
            className="button-icon"
            onClick={() => cancelarModal(data.id, data.operador)}
        >
            <i className="pi pi-times-circle text-danger" />
        </button>
        </div>
    );
    };

 const AceptarCellRenderer = ({ data }) => {
    const estatusId = data?.estatusId;
    if (soloLectura || (estatusId === constantes.estatusSolicitudVacantes.Cerrada  || estatusId=== constantes.estatusSolicitudVacantes.Cancelada )) {
        return null; 
    }
            return (
        <div className="d-flex align-items-center justify-content-center">
            {!soloLectura &&
            <>
                <button title="Autorizar" type="button" className="button-icon"
                        onClick={() => aceptar(data.id)}>
                    <i className="pi pi-check-circle text-success"/>
                </button>
            </>}
        </div>
     );
    };
    const EntrevistaCellRender = ({ data }) => {
     const estatusId = data?.estatusId;

    if (soloLectura || (estatusId === constantes.estatusSolicitudVacantes.Cancelada || estatusId === constantes.estatusSolicitudVacantes.Cerrada)) {
        return null; 
    }

    return (
        <div className="d-flex align-items-center justify-content-center">
            {!soloLectura &&
            <>
                <button title="Autorizar" type="button" className="button-icon"
                        onClick={() => entrevistaModal(data.id)}>
                    <i className="pi pi-user circle text-primary"/>
                </button>
            </>}
        </div>
       );
    };
    const renderFooterModal = () => {
        return (
            <div>
                <Button label="Cerrar" onClick={()=> setVerModal(false)} className="p-button-outlined"/>
                <Button label="Cancelar" onClick={cancelar}  autoFocus/>
            </div>
        );
    };
  const renderFooterModalEntrevista = () => {
        return (
            <div>
                <Button label="Cerrar" onClick={()=> setVerModalEntrevista(false)} className="p-button-outlined"/>
                <Button label="Entrevista" onClick={cancelarEntrevista}  autoFocus/>
            </div>
        );
    };

    return (
        <div className="main-screen caja">                      
            <FormFilter columns={8} filter={filter} onChange={onFilterChange} onClear={onClear} onFilter={filtrar}>
                <Filters>
                    <Field field={"fecha"} label={"Fecha"} render={FormCalendarRange} cols={2}/>                    
                    
                </Filters>
                <Buttons filter={true} clear={true}></Buttons>
            </FormFilter>
            <div className="ag-theme-balham grid-principal">
                <AgGridReact
                    components={{
                        buttonsHeader: ButtonsHeader,
                        buttonsDetail: ButtonsDetail,                        
                        cancelarCellRenderer: CancelarCellRenderer,
                        aceptarCellRenderer: AceptarCellRenderer,
                        entrevistaCellRender: EntrevistaCellRender,
                        dateCellRenderer: DateCellRenderer,
                        nivelSolicitanteCellRenderer: NivelCellRenderer,
                    }}
                    onGridReady={() => filtrar(filter).then()}
                    rowData={datos}
                    overlayLoadingTemplate={agGridHelper.loadingOverlay}
                    defaultColDef={agGridHelper.defaultColumns}
                    context={{onEdit: (id) => setsolicitudVacanteId(id)}}
                    getRowClass={(params) => params.data.nombreColor}
                     rowHeight={40}
                >
                    <AgGridColumn
                        field="fechaSolicitud"
                        headerName="Fecha Solicitud"
                        cellClass="center"
                        cellRenderer="dateCellRenderer"
                        maxWidth={150}
                    />
                    <AgGridColumn field="solicitante" headerName="Solicitante" flex={3} minWidth={100}/>       
                    <AgGridColumn maxWidth={250} field="prioridad" cellClass={'imagen'}  cellRenderer="nivelSolicitanteCellRenderer"/>
                    <AgGridColumn field="dias" headerName="Días transcurridos" width={50}/>
                     <AgGridColumn field="numeroEconomico" headerName="Unidad" width={50}/>
                    <AgGridColumn field="estatus" headerName="Estatus" flex={3} minWidth={100}/>
                    <AgGridColumn maxWidth={150} hide={!esSeccionAutorizar}
                                                     headerName="ACEPTAR"
                                                     cellRenderer="aceptarCellRenderer"/>
                    <AgGridColumn maxWidth={150} hide={esSeccionAutorizar}
                                                     headerName="Entrevista"
                                                     cellRenderer="entrevistaCellRender"/>
                    <AgGridColumn maxWidth={150} hide={!esSeccionAutorizar}
                                                     headerName="CANCELAR"
                                                     cellRenderer="cancelarCellRenderer"/>
                    <AgGridColumn
                        maxWidth={80}
                        headerName="VER"
                        pinned={"right"}
                        headerComponent="buttonsHeader"
                        cellClass={"left"}
                        cellRenderer="buttonsDetail"
                    />
                </AgGridReact>
            </div>
            <SolicituVacantesDetalle
                solicitudVacanteId={solicitudVacanteId}
                puedeEditar={puedeEditar}
                onSaved={() => {
                    filtrar(filter).then();
                    setsolicitudVacanteId(null);
                }}
                onCerrarV={() => {
                    filtrar(filter).then();
                    setsolicitudVacanteId(null);
                }}
                onCancel={() => setsolicitudVacanteId(null)}
                onRefresh={() => filtrar(filter).then()}
                empleado={solicitante}
                />
            <Dialog header={"Cancelar Solicitud"} visible={verModal}
                    footer={renderFooterModal}
                    style={{width: '60vw'}}
                    onHide={() => setVerModal(false)}>
                
                  <FieldCalendar name="fechaCancelacion" label="Fecha Cancelación" colSm={6} disabled={true}
                                    value={fechaCancelacion} className="xs" showButtonBar={false} onChange={(value)=>setFechaCancelacion(value)}/>    
             {!EsOperador &&  
                  <FieldDropDown name="motivoCancelacion" source="motivoCancelacionSolicitud" 
                    label="Motivo Cancelación" value={motivo} onChange={(value)=>setMotivo(value)}
                     required colMd={12}
                  />
              }
              {EsOperador &&         
                <FieldTextArea name="motivoCancelacionOperativo" label="Motivo Cancelación"
                               colMd={12} rows={3}
                               value={motivoCancelacionOperativo}
                               onChange={(value)=>setmotivoCancelacionOperativo(value)}/>
                }
                <FieldTextArea name="comentariosCancelacion" label="Comentarios"
                               colMd={12} rows={3}
                               value={comentario}
                               onChange={(value)=>setComentario(value)}/>
             
            </Dialog>
              <Dialog header={"Solicitar Entrevista"} visible={verModalEntrevista}
                    footer={renderFooterModalEntrevista}
                    style={{width: '60vw'}}
                    onHide={() => setVerModalEntrevista(false)}>
                
                  <FieldCalendar name="fechaEntrevista" label="Fecha Entrevista" colSm={12}
                                    value={fechaEntrevista} className="xs" showButtonBar={false} onChange={(value)=>setFechaEntrevista(value)}/>    

            </Dialog>
        </div>
    );
};

export default SolicitudVacantes;
